import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ObraService } from "src/app/services/obra.service";
import { from } from "rxjs";
import { Obra } from "src/app/models/entities/obra";
import { concatMap, filter, take, map, toArray } from "rxjs/operators";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { Estado } from "src/app/models/entities/estado";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { CatalogoService } from "src/app/services/catalogo.service";
import { TipoConsultaEnum } from "src/app/shared/enums/tipo-consulta-enum.enum";
import { CapaService } from "src/app/services/capa.service";
import { SegmentoService } from "src/app/services/segmento.service";
import { KmlUtils } from "src/app/shared/utils/kml-utils";
import { PptxUtils } from "src/app/shared/utils/pptx-utils";
import { Capa } from "src/app/models/entities/capa";
import { Segmento } from "src/app/models/entities/segmento";
import { PdfUtils } from "src/app/shared/utils/pdf-utils";
import { LoaderService } from "src/app/services/loader.service";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { EjercicioFiscal } from "src/app/models/ejercicio-fiscal";
import { AutenticacionService } from "src/app/services/autenticacion.service";

@Component({
  selector: "home-presupuestos",
  templateUrl: "./home-presupuestos.component.html",
  styleUrls: ["./home-presupuestos.component.scss"],
})
export class HomePresupuestosComponent implements OnInit {
  public mostrarMenu: boolean = false;
  public modalActivo: NgbModalRef;
  public elementoSliderSeleccionado: number = 1;
  public mostrarBotones: boolean = false;
  public mostrarFicha: boolean = false;
  public tipoConsulta: string = "";
  public catEstados: Estado[] = [];
  public catTiposObra: ElementoCatalogo[] = [];
  public catTipoPrioridad: any[] = [];
  public obrasLevantamientos: LevantamientoObra[] = [];
  public obras: Obra[] = [];
  public obrasProceso: ObraDTO[] = [];
  public obrasModal: any[] = [];
  public metaTotal: number = 0;
  public inversionTotal: number = 0;
  public asignacionCompletado: number = 0;
  public metaCompletado: number = 0;
  public asignacionActual: number = 0;
  public metaActual: number = 0;
  public asignacionFaltante: number = 0;
  public metaFaltante: number = 0;

  public fechaActual: Date = new Date();
  public elementosObra: Segmento[] = [];
  public readonly TIPO_OBRA_PROCESO: string = "0";
  public readonly ORIGEN_RECURSOS_FONADIN: string = "1";

  public obraSeleccionada: ObraDTO;

  @ViewChild("modalObrasConcluidas")
  public modalObrasConcluidas: any;

  @ViewChild("modalObrasEjercicioActual")
  public modalObrasEjercicioActual: any;

  @ViewChild("modalObrasCONAGO")
  public modalObrasCONAGO: any;

  @ViewChild("modalObrasCompromisos")
  public modalObrasCompromisos: any;

  @ViewChild("modalObrasPrioritarias")
  public modalObrasPrioritarias: any;

  @ViewChild("modalObrasFONADIN")
  public modalObrasFONADIN: any;

  constructor(
    private router: Router,
    private facadeSesionService: FacadeSesionService,
    private modalService: NgbModal,
    private obraService: ObraService,
    private levantamientoObraService: LevantamientoObraService,
    private catalogoService: CatalogoService,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private kmlUtils: KmlUtils,
    private pdfUtils: PdfUtils,
    private pptxUtils: PptxUtils,
    private loaderScreenService: LoaderService,
    private dateUtils: DateUtils,
    private autenticacionService: AutenticacionService
  ) {}

  public ngOnInit() {
    this.obtenerObras();
  }

  public async obtenerObras() {
    let catalogoTipoObra: ElementoCatalogo[] = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    let catalogoPrioridad: ElementoCatalogo[] = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD)
      .pipe(take(1))
      .toPromise();
    let estados: Estado[] = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.tipoConsulta =
      await this.facadeSesionService.usuarioEnSesionService.obtenerKeyTipoObra();
    this.obras = await this.obraService.findAll().pipe(take(1)).toPromise();
    this.obrasLevantamientos = await this.levantamientoObraService
      .findAll()
      .pipe(take(1))
      .toPromise();
    for (let index = 0; index < this.obras.length; index++) {
      let obra = this.obras[index];
      let keyLevObra = this.obras[index].keyLevantamientoObra;
      let levObra = this.obrasLevantamientos.find(
        (l: LevantamientoObra) => l.key === keyLevObra
      );
      let keyTipoPrioridad = obra.keyCatTipoPrioridad;
      let keyTipoObra = levObra.keyCatTipoObra;
      let keyEstado = levObra.keyCatEstado;
      let obraDto: ObraDTO = {
        nombreEstado: estados.find((e: Estado) => e.key === keyEstado).nombre,
        nombreObra: levObra.nombreObra,
        nombreTipoObra: catalogoTipoObra.find(
          (c: ElementoCatalogo) => c.key === keyTipoObra
        ).nombre,
        nombreTipoPrioridad: catalogoPrioridad.find(
          (c: ElementoCatalogo) => c.key === keyTipoPrioridad
        ).nombre,
        nombreTramoLicitacion: levObra.nombreTramoLicitacion,
        keyCatDireccionAdjunta: levObra.keyCatDireccionAdjunta,
        obra,
      };
      this.obrasProceso.push(obraDto);
    }
    this.mostrarBotones = true;
  }

  public filtrarPorTipoObra(
    tipoConsulta: string,
    keyCatTipoObra: string
  ): boolean {
    if (tipoConsulta === TipoConsultaEnum.ADMINISTRACION) {
      return true;
    }
    if (tipoConsulta === TipoConsultaEnum.PROCESO) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }
    if (tipoConsulta === TipoConsultaEnum.PLANEACION) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }
  }

  public mostrarFichaTecnica(obraRecibida: any) {
    let keyObra = obraRecibida.key;
    let obras = this.obrasProceso;
    let obra = obras.find((o: ObraDTO) => o.obra.key === keyObra);
    this.obraSeleccionada = obra;
    this.mostrarFicha = true;
  }

  public regresar() {
    this.obraSeleccionada = null;
    this.mostrarFicha = false;
  }

  public descargar(): void {
    if (this.obraSeleccionada.obra.incluyeImagenes) {
      // this.pdfUtils.descargarPdf(); //COMENTADA PORQUE AUN NO HAY IMAGENES
      this.pdfUtils.descargarFichaSinImagenes();
    } else {
      this.pdfUtils.descargarFichaSinImagenes();
    }
  }

  public cerrarSesion() {
    this.autenticacionService.cerrarSesion();
  }

  public async descargarKml() {
    this.elementosObra = await this.capaService
      .findByKeyLevantamientoObra(
        this.obraSeleccionada.obra.keyLevantamientoObra
      )
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.kmlUtils.descargarKml(this.elementosObra[0].coordenadas);
  }

  public descargarPowerPoint() {
    this.pptxUtils.descargarPowerPointFichaTecnica(this.obraSeleccionada);
  }

  public navegarBusquedaProceso() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbTipoObra(
      null
    );
    this.facadeSesionService.usuarioEnSesionService.actualizarTipoConsulta(
      "administración"
    );
    this.router.navigate(["/tablero/busqueda-proceso"], {
      skipLocationChange: true,
    });
  }

  public abrirModalObrasConcluidas(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasAnioActual: ObraDTO[] = obras.filter(
      (o: ObraDTO) => o.obra.avanceFisicoGlobal === 100
    );
    let obrasProceso: ObraDTO[] = [];
    for (let index = 0; index < obrasAnioActual.length; index++) {
      for (
        let indice = 0;
        indice < obrasAnioActual[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasAnioActual[index].obra.periodoEjecucion.includes(
            this.fechaActual.getFullYear().toString()
          ) &&
          !obrasAnioActual[index].obra.periodoEjecucion
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          let obraRepetida = obrasProceso.find(
            (o: any) => o.nombreObra === obrasAnioActual[index].nombreObra
          );
          if (!obraRepetida) {
            obrasProceso.push(obrasAnioActual[index]);
          }
        }
      }
    }
    let obrasFinales = obrasProceso.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasConcluidas, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalObrasEjercicioActual(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasOaxaca = obras.filter((o: ObraDTO) => o.nombreEstado === "Oaxaca");
    let obrasCR = obrasOaxaca.filter(
      (o: ObraDTO) => o.keyCatDireccionAdjunta === this.TIPO_OBRA_PROCESO
    );
    let obrasCabeceras = obrasCR.filter(
      (o: ObraDTO) => o.nombreTipoPrioridad === "Cabeceras de Oaxaca"
    );
    let obrasFinales = obrasCabeceras.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasEjercicioActual, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalObrasCompromisos(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasCompromiso = obras.filter(
      (o: ObraDTO) => o.nombreTipoPrioridad === "Compromiso"
    );
    let obrasFinales = obrasCompromiso.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasCompromisos, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalObrasCONAGO(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasConago = obras.filter(
      (o: ObraDTO) => o.nombreTipoPrioridad === "CONAGO"
    );
    let obrasFinales = obrasConago.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasCONAGO, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalObrasPrioritarias(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasPrioritarias = obras.filter(
      (o: ObraDTO) => o.nombreTipoPrioridad === "Prioritaria"
    );
    let obrasFinales = obrasPrioritarias.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasPrioritarias, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public abrirModalObrasFONADIN(): void {
    this.obrasModal = [];
    let obras: ObraDTO[] = this.obrasProceso;
    let obrasFonadin = obras.filter(
      (o: ObraDTO) =>
        o.obra.keyCatOrigenRecursos === this.ORIGEN_RECURSOS_FONADIN
    );
    let obrasFinales = obrasFonadin.sort((a, b) =>
      a.nombreEstado.localeCompare(b.nombreEstado)
    );
    for (let index = 0; index < obrasFinales.length; index++) {
      let asignacionCompletado: number = 0;
      let metaCompletado: number = 0;
      let asignacionActual: number = 0;
      let metaActual: number = 0;
      let asignacionFaltante: number = 0;
      let metaFaltante: number = 0;
      for (
        let indice = 0;
        indice < obrasFinales[index].obra.ejerciciosFiscales.length;
        indice++
      ) {
        if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal <
          this.fechaActual.getFullYear()
        ) {
          //COMPLETADO
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaCompletado += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
            this.fechaActual.getFullYear() &&
          obrasFinales[index].obra.ejerciciosFiscales[
            indice
          ].letrasEsquemaFiscal
            .toUpperCase()
            .includes("POSTERIOR")
        ) {
          //POSTERIOR
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaFaltante += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        } else if (
          obrasFinales[index].obra.ejerciciosFiscales[indice].esquemaFiscal ===
          this.fechaActual.getFullYear()
        ) {
          //ACTUAL
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].asignacion)
            asignacionActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[
                indice
              ].asignacion.toFixed(2)
            );
          if (obrasFinales[index].obra.ejerciciosFiscales[indice].meta)
            metaActual += parseFloat(
              obrasFinales[index].obra.ejerciciosFiscales[indice].meta.toFixed(
                2
              )
            );
        }
      }
      let obraFinal = {
        nombreEstado: obrasFinales[index].nombreEstado,
        nombreObra: obrasFinales[index].nombreObra,
        nombreTramoLicitacion: obrasFinales[index].nombreTramoLicitacion,
        nombreTipoObra: obrasFinales[index].nombreTipoObra,
        nombreTipoPrioridad: obrasFinales[index].nombreTipoPrioridad,
        keyCatDireccionAdjunta: obrasFinales[index].keyCatDireccionAdjunta,
        key: obrasFinales[index].obra.key,
        keyLevantamientoObra: obrasFinales[index].obra.keyLevantamientoObra,
        keyCatTipoObra: obrasFinales[index].obra.keyCatTipoObra,
        fechaActualizacion: obrasFinales[index].obra.fechaActualizacion,
        fechaCracion: obrasFinales[index].obra.fechaCracion,
        keyCatTipoPrioridad: obrasFinales[index].obra.keyCatTipoPrioridad,
        keyCatOrigenRecursos: obrasFinales[index].obra.keyCatOrigenRecursos,
        keyCatCorredor: obrasFinales[index].obra.keyCatCorredor,
        caracteristicas: obrasFinales[index].obra.caracteristicas,
        tpda: obrasFinales[index].obra.tpda,
        estado: obrasFinales[index].obra.estado,
        keyCatCarpeta: obrasFinales[index].obra.keyCatCarpeta,
        keyCatSeccion: obrasFinales[index].obra.keyCatSeccion,
        periodoEjecucion: obrasFinales[index].obra.periodoEjecucion,
        longitudTotal: obrasFinales[index].obra.longitudTotal,
        inversionTotal: obrasFinales[index].obra.inversionTotal,
        esquemaFinanciamiento: obrasFinales[index].obra.esquemaFinanciamiento,
        registroSHCP: obrasFinales[index].obra.registroSHCP,
        estatusSHCP: obrasFinales[index].obra.estatusSHCP,
        proyectoEjecutivo: obrasFinales[index].obra.proyectoEjecutivo,
        liberacionDerechoVia: obrasFinales[index].obra.liberacionDerechoVia,
        cus: obrasFinales[index].obra.cus,
        mia: obrasFinales[index].obra.mia,
        avanceFisicoGlobal: obrasFinales[index].obra.avanceFisicoGlobal,
        avanceFinancieroGlobal: obrasFinales[index].obra.avanceFinancieroGlobal,
        avanceFisico: obrasFinales[index].obra.avanceFisico,
        avanceFinanciero: obrasFinales[index].obra.avanceFinanciero,
        observaciones: obrasFinales[index].obra.observaciones,
        problematica: obrasFinales[index].obra.problematica,
        beneficios: obrasFinales[index].obra.beneficios,
        proximasAcciones: obrasFinales[index].obra.proximasAcciones,
        keyUsuario: obrasFinales[index].obra.keyUsuario,
        asignacionCompletado: asignacionCompletado,
        metaCompletado: metaCompletado,
        asignacionActual: asignacionActual,
        metaActual: metaActual,
        asignacionFaltante: asignacionFaltante,
        metaFaltante: metaFaltante,
      };
      this.obrasModal.push(obraFinal);
    }
    this.asignacionCompletado = 0;
    this.metaCompletado = 0;
    this.asignacionFaltante = 0;
    this.metaFaltante = 0;
    this.asignacionActual = 0;
    this.metaActual = 0;
    this.metaTotal = 0;
    this.inversionTotal = 0;
    this.asignacionCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionCompletado,
      0
    );
    this.metaCompletado = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaCompletado,
      0
    );
    this.asignacionFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionFaltante,
      0
    );
    this.metaFaltante = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaFaltante,
      0
    );
    this.asignacionActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.asignacionActual,
      0
    );
    this.metaActual = this.obrasModal.reduce(
      (prev, curr) => prev + curr.metaActual,
      0
    );
    this.metaTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.longitudTotal,
      0
    );
    this.inversionTotal = this.obrasModal.reduce(
      (prev, curr) => prev + curr.inversionTotal,
      0
    );
    this.modalActivo = this.modalService.open(this.modalObrasFONADIN, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
  }

  public cerrarModalActivo(): void {
    this.mostrarFicha = false;
    this.modalActivo.close();
  }

  public async descargarPDFObrasConcluidas(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let body: any[] = this.obrasModal.map(
      (obraConcluida: any, indice: number) => {
        return [
          { content: indice + 1, styles: { cellPadding: 2 } },
          { content: obraConcluida.nombreEstado, styles: { cellPadding: 2 } },
          { content: obraConcluida.nombreObra, styles: { cellPadding: 2 } },
          {
            content: formatter
              .format(obraConcluida.inversionTotal)
              .substring(3),
            styles: { cellPadding: 2 },
          },
          {
            content: formatter.format(obraConcluida.longitudTotal).substring(3),
            styles: { cellPadding: 2 },
          },
          {
            content: obraConcluida.periodoEjecucion,
            styles: { cellPadding: 2 },
          },
        ];
      }
    );
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasConcluidas(body, foot, base64Img);
  }

  public async descargarPDFCabeceras(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let body: any[] = this.obrasModal.map((obra: any, indice: number) => {
      return [
        { content: indice + 1, styles: { cellPadding: 2 } },
        { content: obra.nombreEstado, styles: { cellPadding: 2 } },
        { content: obra.nombreObra, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.longitudTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: obra.periodoEjecucion, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFinancieroGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFisicoGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
      ];
    });
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", styles: { cellPadding: 2 } },
        { content: "", styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasCabeceras(body, foot, base64Img);
  }

  public async descargarPDFCompromisos(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });
    let body: any[] = this.obrasModal.map((obra: any, indice: number) => {
      return [
        { content: indice + 1, styles: { cellPadding: 2 } },
        { content: obra.nombreEstado, styles: { cellPadding: 2 } },
        { content: obra.nombreObra, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.longitudTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: obra.periodoEjecucion, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFinancieroGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFisicoGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
      ];
    });
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", styles: { cellPadding: 2 } },
        { content: "", styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasCompromisos(body, foot, base64Img);
  }

  public async descargarPDFObrasCONAGO(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });

    let body: any[] = this.obrasModal.map((obra: any, indice: number) => {
      return [
        { content: indice + 1, styles: { cellPadding: 2 } },
        { content: obra.nombreEstado, styles: { cellPadding: 2 } },
        { content: obra.nombreObra, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.longitudTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: obra.periodoEjecucion, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFinancieroGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFisicoGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
      ];
    });
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", styles: { cellPadding: 2 } },
        { content: "", styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasCONAGO(body, foot, base64Img);
  }

  public async descargarPDFObrasPrioritarias(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });

    let body: any[] = this.obrasModal.map((obra: any, indice: number) => {
      return [
        { content: indice + 1, styles: { cellPadding: 2 } },
        { content: obra.nombreEstado, styles: { cellPadding: 2 } },
        { content: obra.nombreObra, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.longitudTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: obra.periodoEjecucion, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFinancieroGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFisicoGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
      ];
    });
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", styles: { cellPadding: 2 } },
        { content: "", styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasPrioritarias(body, foot, base64Img);
  }

  public async descargarPDFObrasFONADIN(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();
    let promesaImgB64: Promise<string> = new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png");
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });
    let base64Img: string = await promesaImgB64;
    let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "MXN",
    });

    let body: any[] = this.obrasModal.map((obra: any, indice: number) => {
      return [
        { content: indice + 1, styles: { cellPadding: 2 } },
        { content: obra.nombreEstado, styles: { cellPadding: 2 } },
        { content: obra.nombreObra, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.longitudTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: obra.periodoEjecucion, styles: { cellPadding: 2 } },
        {
          content: formatter.format(obra.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFinancieroGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(obra.avanceFisicoGlobal).substring(3),
          styles: { cellPadding: 2 },
        },
      ];
    });
    let foot: any = [
      [
        { content: "TOTAL", styles: { cellPadding: 2 } },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.inversionTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaTotal).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", colSpan: 2, styles: { cellPadding: 2 } },
        {
          content: formatter.format(this.asignacionCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaCompletado).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaActual).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.asignacionFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        {
          content: formatter.format(this.metaFaltante).substring(3),
          styles: { cellPadding: 2 },
        },
        { content: "", styles: { cellPadding: 2 } },
        { content: "", styles: { cellPadding: 2 } },
      ],
    ];
    this.pdfUtils.descargarObrasFONADIN(body, foot, base64Img);
  }
}
